import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [addon, setAddon] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    try {
      const res = await api.get('/user/get_me');
      if (res.data?.success) {
        setUser(res.data.data);
        if (res.data.addon) setAddon(res.data.addon);
      } else {
        localStorage.removeItem('rt_token');
      }
    } catch {
      localStorage.removeItem('rt_token');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('rt_token');
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    try {
      const res = await api.post('/user/login', { email, password });
      if (res.data?.success && res.data?.token) {
        localStorage.setItem('rt_token', res.data.token);
        await fetchUser();
        return { success: true };
      }
      return { success: false, msg: res.data?.msg || 'Login failed' };
    } catch (err) {
      return { success: false, msg: 'Connection error' };
    }
  };

  const signup = async ({ name, email, password, mobile_with_country_code }) => {
    try {
      const res = await api.post('/user/signup', {
        name,
        email,
        password,
        mobile_with_country_code,
        acceptPolicy: true,
      });
      if (res.data?.success) {
        // Signup doesn't return token, so login after
        return await login(email, password);
      }
      return { success: false, msg: res.data?.msg || 'Signup failed' };
    } catch (err) {
      return { success: false, msg: 'Connection error' };
    }
  };

  const loginWithGoogle = async (googleToken) => {
    try {
      const res = await api.post('/user/login_with_google', { token: googleToken });
      if (res.data?.success && res.data?.token) {
        localStorage.setItem('rt_token', res.data.token);
        await fetchUser();
        return { success: true };
      }
      return { success: false, msg: res.data?.msg || 'Google login failed' };
    } catch (err) {
      return { success: false, msg: 'Connection error' };
    }
  };

  const logout = () => {
    localStorage.removeItem('rt_token');
    setUser(null);
    setAddon([]);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, addon, login, signup, loginWithGoogle, logout, loading, fetchUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
